import { createContext, useContext } from 'react'

export interface MarketContextValue {
  country_code: string
  language_code: string
}

export const MarketContext = createContext<MarketContextValue>({
  country_code: '',
  language_code: '',
})

export const MarketContextProvider = MarketContext.Provider

export const useMarket = () => {
  const context = useContext(MarketContext)
  if (context === undefined) {
    throw new Error('useMarket was used outside of its Provider')
  }
  return context
}
